export default apiFetch => async payload => {
  const response = await apiFetch({
    endpoint: "subscribe",
    method: "post",
    body: payload
  });

  return await response.json();
};
